module.exports = __webpack_public_path__ + "static/media/12.412ab6eb.JPG";